import React from "react";
import NewsRelated from "./NewsRelated";
import NewDetailContent from "./NewDetailContent";

export default function NewsDetail({initialData}) {
    return (
        <>
            <NewDetailContent initialData={initialData?.detailpage}/>
            <NewsRelated extraClass="related-post" initialData={initialData?.listpage} />
        </>
    );
}